$(document).ready(function() {
    $(document).on('click', '.js-hamburger', function() {
        $('body').addClass('is-modal-open');
        $('.b-header').addClass('menu');
        $('.b-menu').addClass('active');
    });
    $(document).on('click', '.js-close-menu', function() {
        if (!($('.b-header').hasClass('modal'))) {
            $('body').removeClass('is-modal-open');
        }
        $('.b-header').removeClass('menu');
        $('.b-menu').removeClass('active');
    });

    var isSafari = !!navigator.userAgent.match(/safari/i) && !navigator.userAgent.match(/chrome/i) && typeof document.body.style.webkitFilter !== "undefined" && !window.chrome;

    if (isSafari) $('body').addClass('safari');
});


// WEBPACK FOOTER //
// ./src/js/general/menu.js